<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl" v-if="serialModel != null">
                    <SerialDetail :type="type" :serialModel="serialModel"></SerialDetail>
                    <div v-if="isSerial">
                        <Serial :type="type" :serialModel="serialModel" ref="serial"></Serial>
                        <SerialTimer
                            v-if="type != 'surprise-box'"
                            :serialModel="serialModel"
                            :isFromHistory="isFromHistory"
                            @onSerialExpired="onSerialExpired()"
                            @onClickUse="onClickUse()"></SerialTimer>
                        <div v-if="type == 'surprise-box'"
                            class="text-center underline text-green-1 text-20 mb-5"
                            @click="onClickShowCondition()">
                            ดูรายละเอียดและเงื่อนไข
                        </div>
                        <div v-else class="text-center underline text-green-1 text-20" @click="clickShowDetailCondition()">
                            <div v-if="serialModel.condition">
                                เงื่อนไข
                            </div>
                        </div>
                        <div class="px-8 pt-2.5">
                            <div v-if="!serialModel.isNotAutoUse">
                                <div v-if="!serialModel.isUsed" class="bg-green-1 w-full py-2.5 rounded-full text-white text-22 text-center" @click="clickUse()">
                                    กดใช้รหัส
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="px-6">
                        <DetailAndCondition :serialModel="serialModel"></DetailAndCondition>
                        <div v-if="!serialModel.isUsed" class="border border-green-1 w-full py-2.5 rounded-full text-green-1 text-22 text-center" @click="clickBackToSerial()">
                            ย้อนกลับ
                        </div>
                    </div>
                    <div class="w-full py-8">
                        <img class="h-4 m-auto" src="../../../../assets/logo/logo-bzb-new.png" alt=""/>
                    </div>
                    <div class="flex w-full absolute -bottom-1 left-0">
                        <img class="m-auto" @click="clickClose()" src="@/assets/icon/ic-close-circle.svg" alt=""/>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import SerialDetail from "./component/SerialDetail.vue";
import Serial from "./component/Serial.vue";
import SerialTimer from "./component/SerialTimer.vue";
import DetailAndCondition from "./component/DetailAndCondition.vue";

export default {
    name: "SerialModal",
    mixins: [LocaleMixin],
    components: {
        SerialDetail,
        Serial,

        SerialTimer,
        DetailAndCondition
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            serialModel: null,
            isFromHistory: false,
            type: null,
            campaign: null,
            isSerial: true
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            console.log(config.serialModel)
            this.serialModel = config.serialModel;
            this.isFromHistory = config.isFromHistory;
            this.type = config.type

            document.body.classList.add('not-scroll');
            this.isSerial = true;
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickClose: function() {
            this.hide();
            this.controller.sendCloseModal();
        },

        getRedeemMessage: function () {
            let dateStr = DatetimeHelper.getDatetimeFullFormat(this.serialModel.redeemTimestamp);
            return Util.stringFormat(this.lbl.serial.redeem_on, dateStr);
        },

        onSerialExpired: function() {
            this.$refs['serial'].setSerialExpire();
            this.controller.sendSerialExpire();
        },
        onClickUse: function() {
            this.hide();
            this.controller.sendClickUse();
        },
        onClickShowCondition: function() {
            this.hide();
            this.controller.sendShowCondition();
        },
        clickUse: function() {
            this.hide();
            this.controller.sendClickUse();
        },
        clickShowDetailCondition: function() {
            this.isSerial = false;
        },
        clickBackToSerial: function() {
            this.isSerial = true;
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";

    .modal {
        @extend %modal;

        .modal-content {
            overflow: unset;
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 16px;
            }
        }
    }
</style>
